import { render, staticRenderFns } from "./SetupForm.vue?vue&type=template&id=40b4b586&scoped=true&"
import script from "./SetupForm.vue?vue&type=script&lang=js&"
export * from "./SetupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b4b586",
  null
  
)

export default component.exports